import React from "react";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";

// Sprint 8.A.2 — Wrapper für die 4 Haupt-Sections im Cockpit.
// Einheitliches Layout: Icon + Titel + Lock (optional) + Body.

export default function CockpitSection({
  icon: Icon,
  title,
  locked,
  ctaLabel,
  onCta,
  testId,
  children,
}) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      data-testid={testId}
      className={`rounded-2xl border p-5 sm:p-6 ${
        locked ? "bg-slate-50 border-slate-200" : "bg-white border-slate-200 shadow-sm"
      }`}
    >
      <div className="flex items-center gap-2 mb-3">
        {Icon && <Icon className="w-4 h-4 text-[#4563BB]" />}
        <h3 className="text-base font-extrabold tracking-tight text-[var(--fts-text-primary)]">
          {title}
        </h3>
        {locked && <Lock className="w-3.5 h-3.5 text-slate-400 ml-auto" />}
      </div>
      {children}
      {locked && ctaLabel && (
        <button
          type="button"
          onClick={onCta}
          data-testid={`${testId}-cta`}
          className="mt-4 inline-flex items-center gap-1.5 text-xs font-bold text-[#4563BB] hover:underline"
        >
          {ctaLabel} →
        </button>
      )}
    </motion.section>
  );
}
